import { DatabaseId } from "@syla/shared/types/helpers/Id";
import { parseOptional, parseDate } from "@syla/shared/types/helpers/parsing";
import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { PendingWorkResponse } from "@syla/shared/types/responses/PendingWorkResponse";
import axios from "axios";

export async function getPendingWork(
  accountId: DatabaseId,
): Promise<PendingWorkResponse> {
  const response = await axios.get<TransportType<PendingWorkResponse>>(
    `/accounts/${accountId}/status/pendingWork`,
  );
  return deserialise(response.data);
}

function deserialise(
  response: TransportType<PendingWorkResponse>,
): PendingWorkResponse {
  return {
    processing: response.processing,
    syncing: response.syncing,
    updateFrom: parseOptional(response.updateFrom, parseDate),
    updateBalancesFrom: parseOptional(response.updateBalancesFrom, parseDate),
    updateTaxFrom: parseOptional(response.updateTaxFrom, parseDate),
  };
}
